export default () => ({
  loaded: false,
  loading: false,
  ids: [],
  byId: {}
});
